import { render, staticRenderFns } from "./TimelineOfTotalCosts.vue?vue&type=template&id=710d13cc"
import script from "./TimelineOfTotalCosts.vue?vue&type=script&lang=js"
export * from "./TimelineOfTotalCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports